import React, { createContext, useMemo, useState } from 'react';

export const NotificationsContext = createContext<{
  isOpen: boolean;
  handleSetIsOpen: (value: boolean) => void;
}>(null);

const NotificationsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSetIsOpen = (value: boolean) => {
    setIsOpen(value);
  };

  const values = useMemo(() => {
    return {
      isOpen,
      handleSetIsOpen,
    };
  }, [isOpen, setIsOpen]);

  return <NotificationsContext.Provider value={values}>{children}</NotificationsContext.Provider>;
};

export default NotificationsProvider;
